// signupApi.js — calls /api/signup/* endpoints.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

let _dataCache = null;

export async function fetchSignupData() {
  if (_dataCache) return _dataCache;
  const { data } = await axios.get(`${API}/signup/data`);
  _dataCache = data;
  return data;
}

export async function findMatches({ branch, interests, coding }) {
  const { data } = await axios.post(`${API}/signup/find`, { branch, interests, coding });
  return data.matches;
}

export async function sendOtp(email) {
  // Capture X-Dev-OTP header for dev convenience.
  const resp = await axios.post(`${API}/signup/otp/send`, { email });
  const devCode = resp.headers['x-dev-otp'] || null;
  return { ...resp.data, dev_code: devCode };
}

export async function verifyOtpAndCreate(payload) {
  const { data } = await axios.post(`${API}/signup/otp/verify`, payload);
  return data;
}
